<template>
    <v-div>
        <v-card v-if="!user">
            <v-card-title>
                <h3>Use any of the following to subscribe to our newsletter for great discount and important income
                    taxes
                    news</h3>
            </v-card-title>
            <v-card-text>
                <div id="firebaseui-spa">
                    <div id="firesbase-subscribe-container"></div>
                </div>
            </v-card-text>
        </v-card>

        <v-card v-if="user">
            <v-card-title>
                <h3 v-if="!isSubscribed">Welcome {{user.displayName}}</h3>
                <h3 v-if="isSubscribed">Welcome back {{user.displayName}}</h3>
            </v-card-title>
            <v-card-text>
                <v-avatar size="50px">
                    <v-img v-bind:src="user.photoURL" aspect-ratio="2.75"></v-img>
                </v-avatar>
            </v-card-text>
            <v-card-actions>
                <v-btn v-if="!isSubscribed" @click.prevent="subscribe(user.displayName, user.email)">Click to
                    subscribe
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-div>
</template>

<script>
    import firebase from 'firebase';
    import firebaseui from 'firebaseui'
    import {db} from '@/main'

    require('../../../node_modules/firebaseui/dist/firebaseui.css');

    var uiConfig = {
        signInSuccessUrl: '/contact',
        signInOptions: [
            firebase.auth.GoogleAuthProvider.PROVIDER_ID,
            firebase.auth.EmailAuthProvider.PROVIDER_ID,
            firebase.auth.FacebookAuthProvider.PROVIDER_ID,
            firebase.auth.TwitterAuthProvider.PROVIDER_ID
        ]
    };

    var ui;
    const userSubColl = "userSubscription";
    export default {
        name: "ContactForm",
        data: () => ({
            user: null,
            isSubscribed: false
        }),
        methods: {
            subscribe(name, email) {
                db.collection(userSubColl).doc(email).set({
                    name: name,
                    active: true,
                    createDate: new Date()
                }).then(() => this.$router.push({
                        name: 'Home'
                    })
                ).catch(function (error) {
                    console.log(error)
                })
            }
        },
        created() {
            firebase.auth().onAuthStateChanged((user) => {
                if (user) {
                    this.user = user
                    db.collection(userSubColl).doc(user.email).get().then((user) =>
                        this.isSubscribed = user.exists
                    );
                } else {
                    this.user = null
                    this.isSubscribed = false
                }
            })
        },
        mounted() {
            if (!ui) {
                ui = new firebaseui.auth.AuthUI(firebase.auth());
            }
            ui.start('#firesbase-subscribe-container', uiConfig);
        }
    }
</script>

<style scoped>
    #firesbase-subscribe-container {
        padding: 50px 0;
    }
</style>


// WEBPACK FOOTER //
// src/components/contact/ContactForm.vue